import { createSelector } from "@reduxjs/toolkit";
/**
 * Returns the format that the data is displayed
 */
export const dataViewModeSelector = createSelector(state => state.ui, uiState => {
  return uiState.dataViewMode;
});

/**
 * Returns the sidebar property
 */
export const sidebarSelector = createSelector(state => state.ui, uiState => {
  return uiState.sidebar;
});

/**
 * Returns the search property
 */
export const searchSelector = createSelector(state => state.ui, uiState => {
  return uiState.search;
});

/**
 * Returns the numUnreadMsg property
 */
export const numUnreadMsgSelector = createSelector(state => state.ui, uiState => {
  return uiState.numUnreadMsg;
});

/**
 * Returns the world map style property
 */
export const worldMapStyleSelector = createSelector(state => state.ui, uiState => {
  return uiState.worldMapStyle;
});

/**
 * Returns whether the world map is rendered in 3D
 */
export const worldMapModeSelector = createSelector(state => state.ui, uiState => {
  return uiState.worldMapMode;
});